const API_URL = process.env.REACT_APP_BLOG_API_URL || '';

export interface ContactPayload {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export async function sendContactMessage(payload: ContactPayload): Promise<void> {
  if (!API_URL) {
    throw new Error('Contact API is not configured');
  }

  // No x-api-key header here: the /contact route has no API Gateway usage
  // plan enforcing one, and sending it trips CORS (the Lambda's OPTIONS
  // response only allows Content-Type/Authorization).
  const res = await fetch(`${API_URL}/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || `Request failed with status ${res.status}`);
  }
}
